import { memo } from 'react'
import Icon from '../../../../../components/Icon'

import './index.scss'
import { ICON } from '../../../../../components/Icon/data'
import { DateTime } from 'luxon'

type LastPosCol = {
  val: string
}

const LastPosCol = memo(({ val }: LastPosCol) => {
  const now = DateTime.now()
  const lastPosititon = DateTime.fromISO(val)
  if (!lastPosititon.isValid) return val

  let format = 'HH:mm'
  const posWarning = now.diff(lastPosititon).as('hours') > 24
  if (posWarning) {
    format = 'dd/LL'
  }

  return (
    <div className="LastPosCol">
      {posWarning && (<Icon icon={ICON.WARNING} color="#F49C18" />)}
      {DateTime.fromISO(val).toFormat(format)}
    </div>
  )
})

export default LastPosCol
